/* jshint esversion: 6 */

function init() {
  const selectChangeLocation = document.querySelectorAll('.js-select-change-location');

  selectChangeLocation.forEach(function(element) {

    /** Redirect to Select Option Value on change */
    element.addEventListener('change', function (event) {
      window.location.href = this.value;
      // window.location.href = this.options[this.selectedIndex].dataset.permalink;
    });

    /** Redirect to Select Option Value on keyup */
    element.addEventListener('keyup', function (event) {
      window.location.href = this.value;
      // window.location.href = this.options[this.selectedIndex].dataset.permalink;
    });

    /** Reset Selected State on back_forward */
    if (String(window.performance.getEntriesByType('navigation')[0].type) === 'back_forward') {
      var elementSelectedIndex = element.selectedIndex;

      window.addEventListener('pageshow', function(event) {
        element.selectedIndex = elementSelectedIndex;
      });
    };
  });
}

export { init as default };
